// extracted by mini-css-extract-plugin
export default {"readMoreContainer":"readmore_readMoreContainer__SKv35","toggleButton":"readmore_toggleButton__TrNq5"};